const GroupModel = require('common/domain/entity/group');
const Backbone = require('backbone');

module.exports = Backbone.Collection.extend({
    /**
     * Backbone.Collection を extend した GroupCollection を定義する
     */
    model: GroupModel,
    comparator: function(group) {
        return group.get('name').toLowerCase();
    }
});



// WEBPACK FOOTER //
// ./common/domain/collection/group.js